import {
  ROOT,
  GET_ALL_PLAN,
  GET_PLAN_DETAIL,
  DELETE_PLAN,
  CREATE_PLAN,
  UPDATE_PLAN,
  DUPLICATE_PLAN
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function get() {
  return fetch(ROOT + GET_ALL_PLAN, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getDetail(id) {
  return fetch(ROOT + GET_PLAN_DETAIL + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function create(data) {
  return fetch(ROOT + CREATE_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function update(data) {
  return fetch(ROOT + UPDATE_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function duplicate(data) {
  return fetch(ROOT + DUPLICATE_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function remove(id) {
  return fetch(ROOT + DELETE_PLAN + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion
export const salePackageService = {
  get,
  getDetail,
  create,
  update,
  remove,
  duplicate
};
